<template>
  <b-row>
    <b-col lg="12">
      <h3>{{ $t("exams.exams") }}</h3>
      <hr />
      <b-list-group>
        <b-list-group-item
          class="d-flex"
          v-for="exam in exams"
          :key="exam.id"
          button
          @change="changeExam(exam)"
        >
          <b-form-radio
            v-model="examSelected"
            :value="exam.id"
            name="some-radio9"
            class="custom-control-primary"
          >
            {{ exam.name }}
          </b-form-radio>
        </b-list-group-item>
      </b-list-group>
    </b-col>
    <hr />

    <b-col lg="6">
      <b-button block variant="primary" @click="submit()">
        <i class="fa fa-plus" /> {{ $t("site.save") }}
      </b-button>
    </b-col>
    <b-col lg="6">
      <b-button block  @click="goToTable()"  variant="success">
        <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import EduProgramsController from "@/Controllers/EduProgramsController";
export default {
  data() {
    return {
      courses: [],
      exams: [],
      courseSelected: {},
      officialExams: [],
      examSelected: 0,
    };
  },
  created() {
    new EduProgramsController()
      .AssignOfficialExams(this.$route.params.eduProgramId)
      .then((res) => {
        this.courses = res.courses;
        this.seleteCourse(this.courses[0]);
      });
  },
  methods: {
    seleteCourse(course) {
      this.courseSelected = course;
      this.exams = course.exams;
      this.examSelected = course.pivot.official_exam_id;
    },
    changeExam(exam) {
      this.courseSelected.pivot.official_exam_id = exam.id;
    },
  },
};
</script>

<style>
</style>